import React, { useReducer, createContext, useContext } from "react";

let reducer = (state, data) => {
  return { ...state, ...data };
};

const initialState = {
  sizePerPage: "All",
  page: 1,
  search: "",
  sortBy: "firstName",
  direction: "asc",
};

const InvestorsContext = createContext(initialState);

const InvestorsProvider = ({ children }) => {
  const stateAndDispatch = useReducer(reducer, initialState);
  return (
    <InvestorsContext.Provider value={stateAndDispatch}>
      {children}
    </InvestorsContext.Provider>
  );
};

export const useInvestors = () => useContext(InvestorsContext);

export { InvestorsContext, InvestorsProvider };
